<template>
	<div class="relative overflow-hidden px-3 py-4" data-testid="journey-vehicle">
		<dt class="flex items-center gap-3">
			<div
				class="flex items-center justify-center rounded-md w-8 h-8"
				:class="theme"
				data-testid="icon">
				<app-tooltip :text="vehicle.type" position-y="bottom">
					<app-icon :icon="['fas', 'fa-truck']" class="text-white -mb-[2px]" />
				</app-tooltip>
			</div>

			<div class="flex flex-col">
				<span class="text-xs font-medium text-gray-900" data-testid="vehicle-code">
					{{ vehicle.code }}
				</span>

				<p
					class="text-md font-semibold leading-5 text-gray-900"
					data-testid="vehicle-registration">
					{{ vehicle.registration }}
				</p>
			</div>

			<p
				class="inline-flex items-center ml-auto justify-center text-[10px] rounded-full w-5 h-5 text-white bg-blue-600 shrink-0"
				data-testid="vehicle-journeys">
				{{ totalJourneys }}
			</p>
		</dt>
		<dd class="flex items-baseline pb-6 mt-2">
			<p class="text-xs font-normal text-gray-500" data-testid="vehicle-name">
				{{ vehicle.name }}
			</p>
		</dd>
	</div>
</template>

<script lang="ts" setup>
	import AppTooltip from '@/components/base/AppTooltip.vue'
	import type { Vehicle } from '@/data/schema/vehicle'
	import { computed } from 'vue'

	const props = withDefaults(
		defineProps<{
			vehicle: Vehicle
		}>(),
		{}
	)

	const theme = computed(() => {
		switch (props.vehicle.type) {
			case 'Own Transport':
				return 'bg-mabey-950'
			case 'External Haulier':
				return 'bg-yellow-500'
			default:
				return 'bg-mabey-950'
		}
	})

	const totalJourneys = computed(() => {
		return Object.values(props.vehicle.journeys!).reduce(
			(sum, journeys) => sum + journeys.length,
			0
		)
	})
</script>
